import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Wallet, BadgeCheck } from "lucide-react";

export default function EnveloppeDialog({ open, onOpenChange, form, setForm, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="enveloppe-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Wallet className="w-5 h-5 text-amber-600" />
            Compte-rendu financier de la tournée
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-2">
          {/* Cash */}
          <div className="p-3 rounded-lg border border-emerald-200 bg-emerald-50/50 space-y-3">
            <p className="text-sm font-semibold text-emerald-800">💵 Cash</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Montant cash (€)</Label>
                <Input type="number" step="0.01" min="0" placeholder="Ex: 250" value={form.montant} onChange={(e) => setForm({ ...form, montant: e.target.value })} data-testid="enveloppe-montant-input" />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Nombre de chaises</Label>
                <Input type="number" min="0" placeholder="Ex: 8" value={form.nb_chaises} onChange={(e) => setForm({ ...form, nb_chaises: e.target.value })} data-testid="enveloppe-nb-chaises-input" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Checkbox id="enveloppe_remise" checked={form.remise} onCheckedChange={(v) => setForm({ ...form, remise: !!v })} data-testid="enveloppe-remise-checkbox" />
              <Label htmlFor="enveloppe_remise" className="cursor-pointer text-sm">Cash remis au bureau</Label>
              {form.remise && (
                <Input type="date" value={form.date_remise} onChange={(e) => setForm({ ...form, date_remise: e.target.value })} className="h-8 ml-auto w-40" data-testid="enveloppe-date-remise-input" />
              )}
            </div>
          </div>

          {/* Virement */}
          <div className="p-3 rounded-lg border border-blue-200 bg-blue-50/50 space-y-3">
            <p className="text-sm font-semibold text-blue-800">🏦 Virements reçus</p>
            <div className="space-y-1">
              <Label className="text-xs">🏢 Sur compte Cocoon-Elec (€)</Label>
              <Input type="number" step="0.01" min="0" placeholder="Ex: 500" value={form.virement_cocoon_montant} onChange={(e) => setForm({ ...form, virement_cocoon_montant: e.target.value })} data-testid="virement-cocoon-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">👤 Sur compte livreur (€)</Label>
                <Input type="number" step="0.01" min="0" placeholder="Ex: 150" value={form.virement_livreur_montant} onChange={(e) => setForm({ ...form, virement_livreur_montant: e.target.value })} data-testid="virement-livreur-montant-input" />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Nom du livreur</Label>
                <Input placeholder="Ex: Ahmed" value={form.virement_livreur_nom} onChange={(e) => setForm({ ...form, virement_livreur_nom: e.target.value })} data-testid="virement-livreur-nom-input" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Checkbox id="virement_remise" checked={form.virement_remise} onCheckedChange={(v) => setForm({ ...form, virement_remise: !!v })} data-testid="virement-remise-checkbox" />
              <Label htmlFor="virement_remise" className="cursor-pointer text-sm">Virement livreur remboursé</Label>
              {form.virement_remise && (
                <Input type="date" value={form.virement_date_remise} onChange={(e) => setForm({ ...form, virement_date_remise: e.target.value })} className="h-8 ml-auto w-40" data-testid="virement-date-remise-input" />
              )}
            </div>
          </div>

          <Button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-700" data-testid="save-enveloppe-btn">
            <BadgeCheck className="w-4 h-4 mr-2" />
            Enregistrer
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
